import React from 'react';

// IMPORT STYLES
import './Tags.css';

// IMPORT CONSTANTS
import {
  TAGS,
  TAGS_ALT,
} from './constants';

function Tags() {

  return(
    <img
    className='tags'
    src={TAGS}
    alt={TAGS_ALT}
  />
  );
}
export default Tags;
